import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import LocationsNavigationIcon from 'Icons/NavigationItem/Locations';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyLocationsSettingsPage = React.lazy(() => import('./Pages'));

const companyConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.locations.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.locations.title',
            url: '/location-settings',
            Icon: LocationsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyLocationsSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default companyConfiguration;
